import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import { useParams } from "react-router-dom";
import ButtonsSelect from "../Components/Common/ButtonsSelect";
import csv1 from '../Data/EUMACP/Commodity/EU-MACP-Commodity-of-samples-with-quantified-above-the-MRL.csv';
import csv2 from '../Data/EUMACP/Commodity/EU-MACP-Commodity-No-of-quantified-residues-per-sample.csv';
import csv3 from '../Data/EUMACP/Commodity/EU-MACP-Commodity-Residues-expressed-as-percentage-of-MRL-Below-100.csv';
import csv4 from '../Data/EUMACP/Commodity/EU-MACP-Commodity-Residues-expressed-as-percentage-of-MRL-Above-100.csv';
import csv5 from '../Data/EUMACP/Commodity/EU-MACP-Commodity-Pesticides-with-significant-differences-in-quantification-and-above-LL-results-compared-to-previous-year.csv';
import csv6 from '../Data/EUMACP/Commodity/EU-MACP-Commodity-summary-of-findings-table-per-commodity.csv';
import Intro from "../Components/Commodity/Intro";
import MultiLineChart from "../Components/Charts/MultiLineChart";
import RingChart from "../Components/Charts/RingChart";
import ScatterDotsChart from "../Components/Charts/ScatterDotsChart";
import { useState } from "react";
import HorizontalBarChartWIthNegative2 from "../Components/Charts/HorizontalBarChartWIthNegative2";
import SummaryDataGrid from "../Components/Commodity/SummaryDataGrid";
import CommodityMap from "../Components/Maps/CommodityMap";
import mapJSON from '../Data/JSON/World.json';
import mapCSV from '../Data/EUMACP/Commodity/EU MACP-Commodity-Samples-with-quantified-residues-above-the-MRL-and-non-compliant-by-country-of-origin.csv';

const Commodity = (props) => {
    const { id } = useParams();
    const capitalize = id.charAt(0).toUpperCase() + id.slice(1);
    const denormalize = capitalize.replace('-', ' ');

    const [residuesCSV, setResiduesCSV] = useState(csv3);
    const [residuesActive, setResiduesActive] = useState(0);

    const [buttonsFilter, setButtonsFilter] = useState('Above legal limit result');

    const handleResiduesClick = (value) => {
        if (value === 0) {
            setResiduesCSV(csv3);
            setResiduesActive(0)
        } else {
            setResiduesCSV(csv4);
            setResiduesActive(1);
        }
    }

    const handleButtonClick = (value) => {
        if (value === 0) {
            setButtonsFilter('Above legal limit result');
        } else {
            setButtonsFilter('Result non compliant for pesticides');
        }
    }

    return (
        <Grid p={2} container direction="column" className="chapterOneWrapper">
            <Grid item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: '20px' }} justifyContent='center'>
                <Box sx={{ width: '100%', padding: '2rem', backgroundColor: '#FAFAFA' }}>
                    <Intro id={id} name={denormalize} />
                </Box>
            </Grid>

            <Grid item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }} justifyContent='center'>
                <Box sx={{ width: { xs: '90%', sm: '90%', md: '60%' } }}>
                    <MultiLineChart legendPosition='bottom' filter={denormalize} commodity title='% of samples with quantified above the MRL' csv={csv1} />
                </Box>
            </Grid>

            <Grid item container direction='column' sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }} justifyContent='center'>
                <Box sx={{ maxWidth: '100%' }}>
                    <ButtonsSelect firstButton='Above legal limit' secondButton='Non compliant' onButtonClick={handleButtonClick} />

                </Box>
                <Box>
                    <p>Samples with quantified residues above the MRL and non-compliant by country of origin</p>
                    <CommodityMap buttonsFilter={buttonsFilter} filter={denormalize} csv={mapCSV} json={mapJSON} />
                </Box>
            </Grid>

            <Grid item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }} justifyContent='center'>
                <RingChart filter={denormalize} title='no. of quantified residues per sample' csv={csv2} />
            </Grid>

            <Grid item container direction='column' sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }} alignItems='center'>
                <Box sx={{ maxWidth: '100%' }}>
                    <ButtonsSelect firstButton='Below 100%' secondButton='Above 100%' onButtonClick={handleResiduesClick} />
                </Box>
                <Box sx={{ width: '98%' }}>
                    <ScatterDotsChart residuesActive={residuesActive} title='Residues expressed as percentage of MRL' filter={denormalize} csv={residuesCSV} />
                    <Box mt={'1rem'} display='flex' justifyContent='center'>
                        <p style={{ fontFamily: 'Roboto Condensed, sans-serif', maxWidth: '700px', textAlign: 'center' }}>Values in the parentheses denote: a. the number of samples below LOQ, b. the number of samples between LOQ and MRL and, c.the number of samples above MRL: e.g. 2,4-D (RD) (a, b, c) </p>
                    </Box>
                </Box>
            </Grid>
            <Grid item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }} justifyContent='center'>
                <Box sx={{ width: { xs: '100%', sm: '100%', md: '70%' } }}>
                    <HorizontalBarChartWIthNegative2 title='Pesticides with significant increase/decrease compared to previous year' csv={csv5} filter={denormalize} />
                </Box>
            </Grid>

            {denormalize === "Poultry fat" &&
                <Grid item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }} justifyContent='center'>
                    <Box>
                        <p style={{ textAlign: 'center' }}><b><u>Disclaimer</u></b></p>
                        <p style={{ textAlign: 'center', maxWidth: '700px' }}>For the purposes of this visualisation the <b>poultry fat</b>, poultry tissue and poultry muscle samples, and subsequently results, are pooled together. </p>
                    </Box>
                </Grid>
            }

            <Grid item container direction={{ xs: 'column', sm: 'column', md: 'row' }} sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }} justifyContent='center'>
                <Box sx={{ width: { xs: '100%', sm: '100%', md: '80%' } }}>
                    <SummaryDataGrid title='Summary of the findings' filter={denormalize} csv={csv6} />
                </Box>
            </Grid>


        </Grid>

    );
}

export default Commodity;